// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ProjectLocationMode,
} from "./types";


export default __t.row({
  configId: __t.u32().primaryKey().name("config_id"),
  get projectLocation() {
    return ProjectLocationMode.name("project_location");
  },
  useFirstTwinFallback: __t.bool().name("use_first_twin_fallback"),
  startupMap: __t.option(__t.string()).name("startup_map"),
});
